/** Lê filtros avançados do DataTable (query → value). */
export function readDatatableFilterMap(datatableRef) {
  const dt = datatableRef;
  if (!dt || !Array.isArray(dt.filtrosAvancados)) {
    return {};
  }
  return dt.filtrosAvancados.reduce((acc, filter) => {
    if (filter && filter.query) {
      acc[filter.query] = normalizeFilterQueryValue(filter.value);
    }
    return acc;
  }, {});
}

export function readDatatableSearch(datatableRef) {
  const dt = datatableRef;
  if (!dt) return "";
  return String(dt.searchValue || "").trim();
}

/** Valor enviado na query string (autocomplete pode ser objeto { text, value }). */
export function normalizeFilterQueryValue(value) {
  if (value === undefined || value === null) return "";
  if (typeof value === "object" && value.value !== undefined) {
    return value.value === null || value.value === undefined
      ? ""
      : String(value.value);
  }
  return String(value);
}
